import { makeAutoObservable, runInAction } from 'mobx';
import { InvestownMonthlyStatusMobxDto } from '../mobx/dtos/investown/investown-monthly-status-mobx-dto';
// eslint-disable-next-line import/no-cycle
import { StatisticStore } from './statistic/statistic-store';
import { OrderEnum } from '../../defs/api';

/**
 * InvestownAssetStore – dočasně napojen na stejná data jako PersonalAssetStore.
 */

export class InvestownAssetMonthlyStatusStore {
    statisticStore: StatisticStore;

    monthlyStatus: InvestownMonthlyStatusMobxDto[] = [];

    monthlyStatusPaginated: InvestownMonthlyStatusMobxDto[] = [];

    loading = false;

    limit = 5;

    totalCount = 0;

    page = 1;

    constructor(statisticStore: StatisticStore) {
        this.statisticStore = statisticStore;
        makeAutoObservable(this, {
            statisticStore: false,
        });
    }

    startLoading(): void {
        this.loading = true;
    }

    stopLoading(): void {
        this.loading = false;
    }

    async fetchMonthlyStatus(): Promise<void> {
        this.startLoading();
        const parameters = {
            portfolioId: this.statisticStore.rootStore.portfolioStore.selectedPortfolio.id,
            limit: 6,
            offset: 0,
            order: OrderEnum.Desc,
        };

        const fetched = this.statisticStore.rootStore.portfolioStore.sharedPortfolio
            ? await this.statisticStore.rootStore.apiClient.statisticsController.sharedStatisticControllerGetInvestownCharts(
                  parameters,
              )
            : await this.statisticStore.rootStore.apiClient.statisticsController.statisticControllerGetInvestownChartData(
                  parameters,
              );

        runInAction(() => {
            this.monthlyStatus = InvestownMonthlyStatusMobxDto.createFromArray(fetched.items);
            this.stopLoading();
        });
    }

    async fetchMonthlyStatusPaginated(): Promise<void> {
        this.startLoading();
        const parameters = {
            portfolioId: this.statisticStore.rootStore.portfolioStore.selectedPortfolio.id,
            limit: this.limit,
            offset: (this.page - 1) * this.limit,
            order: OrderEnum.Desc,
        };

        const fetched = this.statisticStore.rootStore.portfolioStore.sharedPortfolio
            ? await this.statisticStore.rootStore.apiClient.statisticsController.sharedStatisticControllerGetInvestownCharts(
                  parameters,
              )
            : await this.statisticStore.rootStore.apiClient.statisticsController.statisticControllerGetInvestownChartData(
                  parameters,
              );

        runInAction(() => {
            this.monthlyStatusPaginated = InvestownMonthlyStatusMobxDto.createFromArray(fetched.items);
            this.limit = fetched.limit;
            this.totalCount = fetched.total;
            this.stopLoading();
        });
    }

    async setPage(page: number): Promise<void> {
        this.page = page;
        await this.fetchMonthlyStatusPaginated();
    }

    setPageLimit(limit: number | string | null): void {
        if (limit && !Number.isNaN(limit)) {
            this.limit = +limit;
            this.setPage(1);
        }
    }

    get pagesCount(): number {
        return Math.ceil(this.totalCount / this.limit) || 0;
    }
}
